<div class="card card-custom gutter-b card-stretch">
    <div class="idms_view_title">
        <h3>Configure iDMS Views</h3>
    </div>
    <div class="idms_view_details">
        <ul *ngIf="isCreate">
            <li *ngFor="let view of idmsView">
                <a href="javascript:void(0)">
                    <img src="../../../../../../assets/media/logos/configure-item.png" /> </a
                >{{ view.name }} <mat-icon #tooltip="matTooltip" matTooltip="Edit" (click)="openHierarchyOptionEditModal(view, mymodal_edit)">edit</mat-icon>
            </li>
        </ul>
        <ul *ngIf="!isCreate">
            <li *ngFor="let view of idmstagItem">
                <a href="javascript:void(0)">
                    <img src="../../../../../../assets/media/logos/configure-item.png" /> </a
                >{{ view.name }} <mat-icon #tooltip="matTooltip" matTooltip="Edit" (click)="openHierarchyOptionEditModal(view, mymodal_edit)">edit</mat-icon>
            </li>
        </ul>
    </div>
</div>
